import { reemaColors } from '@act/storybook';
import styled from 'styled-components';

export const RecordContainer = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 19px;
  align-self: stretch;
  border-radius: var(--Border-Radius, 8px);
  border: 1px solid var(--Stroke-stroke-primary, #dce4e8);
  background: var(--Surface-bg-surface-secondary, #fff);
  margin-bottom: 24px;
`;
export const DeleteButtonContainer = styled.div`
  display: flex;
  margin: auto;
  margin-right: 0;
  margin-left: auto;
  flex-grow: 0;
  flex-shrink: 0;
`;
export const ContainerDiv = styled.div`
  display: grid;
  height: 100%;
  grid-template-rows: auto 1fr;
  background-color: ${reemaColors.lightBackground};
`;

export const HeaderDiv = styled.div`
  display: flex;
  width: 100%;
  padding: 18px 32px;
  background-color: #ffffff;
  align-content: center;
  box-sizing: border-box;
  z-index: 1000;
  box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.08),
    0px 1px 2px 0px rgba(0, 0, 0, 0.16);
`;

export const FieldWrapper = styled.div`
  flex: 1;
  padding: 8px 4px;
`;
